import { render } from "./ChildTeacherConsent.vue?vue&type=template&id=977137ca&scoped=true"
import script from "./ChildTeacherConsent.vue?vue&type=script&lang=js"
export * from "./ChildTeacherConsent.vue?vue&type=script&lang=js"

import "./ChildTeacherConsent.vue?vue&type=style&index=0&id=977137ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977137ca"]])

export default __exports__